/*
 * 弹框新手引导
 */

(function($) {

$(function() {

  // 弹框里面的帮助视频
  $(document).on('click', '.bubble-videos a', function(e) {
    e.preventDefault();

    var $this = $(this);
    var poster = $this.data('poster') || '';
    var $video = $('<div id="video-popover">\
          <video autoplay="ture" controls="true" height="576"\
            poster="' + poster + '" preload="auto" width="1024">\
            <source src="' + $this.data('src') + '" type="video/mp4">\
          </video>\
          <a id="close" href="javascript:;" title="关闭视频">关闭</a>\
        </div>');

    $(document.body).append('<div id="mask" class="video"></div>');
    $(document.body).append($video);
    $video.fadeIn();

    var $mask = $('#mask');
    $mask.on('click', closeVideo);
    $video.on('click', '#close', closeVideo);

    function closeVideo() {
      $mask.addClass( "hidden" ).remove();
      $video.fadeOut().remove();
    }

    $this.closest('.simple-popover').find('.btn').trigger('click');
  });

  $(document)
  .on('ajax:success', '.bubble-buttons .btn', function(e, result) {
    tower.unusedBubbles = result.steps;
    tower.bubbleGuideChange();
  });

  tower.stack.on('pageunload', function(e) {
    simple.popover.destroyAll();
    return e.result;
  });
});

var bubbleGuideMethods = {
  "8": function() {
    var $pointTo = $('#page-calendar .link-create-calendar');
    var $tpl = $('#tpl-bubble-guide-8');
    if (!$pointTo.length || !$tpl.length) { return }
    return simple.popover({
      pointTo: $pointTo,
      content: $tpl.html(),
      position: 'bottom-left',
      cls: 'popover-bubble-guide'
    });
  },

  "10": function() {
    var $pointTo = $('#page-members .btn-invite-members');
    var $tpl = $('#tpl-bubble-guide-10');
    if (!$pointTo.length || !$tpl.length) { return }
    return simple.popover({
      pointTo: $pointTo,
      content: $tpl.html(),
      position: 'bottom-left',
      cls: 'popover-bubble-guide'
    });
  },

  "14": function() {
    var $pointTo = $('#page-projects .link-create-project');
    var $tpl = $('#tpl-bubble-guide-14');
    if (!$pointTo.length || !$tpl.length) { return }
    return simple.popover({
      pointTo: $pointTo,
      content: $tpl.html(),
      position: 'bottom-left',
      cls: 'popover-bubble-guide'
    });
  }
}

$.extend(window.tower, {
  hasBubble: function(step) {
    return tower.unusedBubbles.indexOf(step) >= 0;
  },

  isBubbleShowing: function(step) {
    return !!$('.bubble-guide-' + step).length
  },

  bubbleGuideChange: function() {
    tower.showBubbleGuide();
  },

  bubbleGuideIgnore: function(opts) {
    if (!opts || !$.isNumeric(opts.step)) {
      return
    }

    $.ajax({
      url: '/users/destroy_bubble_guides?steps=' + opts.step,
      type: 'delete',
      dataType: 'json',
      success: function(result) {
        tower.unusedBubbles = result.steps;
        tower.showBubbleGuide();
      }
    });
  },

  bubbleGuideClose: function(opts) {
    if (!opts || !$.isNumeric(opts.step)) {
      return
    }

    $('.bubble-guide-' + opts.step)
      .find('.bubble-buttons .btn-primary, .btn-close')
      .trigger('click');
  },

  bubbleGuideExpire: function(opts) {
    if (!opts || !$.isNumeric(opts.step)) {
      return
    }

    var bubbleEl = $('.bubble-guide-' + opts.step).closest('.bubble'),
      bubble = bubbleEl.data('bubbleInstance');

    if (bubble) {
      bubble.destroy();
    }

    $.ajax({
      url: '/users/destroy_bubble_guides?steps=' + opts.step,
      type: 'delete',
      success: function(result) {
        tower.unusedBubbles = result.steps;
      }
    });
  },

  showBubbleGuide: function(opts) {
    simple.popover.destroyAll();

    if (!tower.unusedBubbles.length) {
      return
    }

    opts = $.extend({
      steps: null
    }, opts);

    var bubbles = [];

    if (opts.steps) {
      bubbles = opts.steps;
    } else if (typeof PAGE_BUBBLE_GUIDES !== "undefined"
          && $.isArray(PAGE_BUBBLE_GUIDES)) {
      bubbles = PAGE_BUBBLE_GUIDES;
    } else {
      return
    }

    var pageBubbles = tower.arrayIntersection(bubbles, tower.unusedBubbles);

    if (pageBubbles.length) {
      var step = pageBubbles[0],
        bubble = bubbleGuideMethods[step](opts);

      if (bubble) {
        $(document).trigger('bubbleGuide:show', {step: step});
      }
    }
  }
});

})(jQuery);
